export default {
    selectedCaseStudy: null,
    caseStudyStatistics: null,
    isProjectSubmitted: false,
    projectDetails: null,
}